import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../../../store';

export enum PushyBannerState {
  NOT_CONNECTED = 'NOT_CONNECTED',
  CONNECTED = 'CONNECTED',
}

type AppState = {
  areTranslationsLoading: boolean;
  pushyConnectionBanner: PushyBannerState | null;
};

const initialState: AppState = {
  areTranslationsLoading: true,
  pushyConnectionBanner: null,
};

const appSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    setAreTranslationsLoading: (state, action: PayloadAction<boolean>) => {
      state.areTranslationsLoading = action.payload;
    },
    setPushyConnectionBanner: (state, action: PayloadAction<PushyBannerState | null>) => {
      state.pushyConnectionBanner = action.payload;
    },
  },
});

export const { setAreTranslationsLoading, setPushyConnectionBanner } = appSlice.actions;

export const selectAreTranslationsLoading = (state: RootState) => state.app.areTranslationsLoading;
export const selectPushyConnectionBanner = (state: RootState) => state.app.pushyConnectionBanner;

export default appSlice.reducer;
